import { useEffect, useRef } from 'react';
import useFilteredCanvas from '@components/MainStage/hooks/useFilteredCanvas';
import useMultiSelectEntity from '@components/MainStage/hooks/useMultiSelectEntity';
import { isEditableTextTarget } from '@utils/isEditableTextTarget';

/**
 * Cmd/Ctrl+A selects all entities in the model canvas / list. Registered
 * globally while the model canvas is mounted (model tab, including what-if
 * scenarios).
 */
const useSelectAllShortcut = () => {
  const { selectAll } = useMultiSelectEntity();

  const { nodes } = useFilteredCanvas({ applyCollapse: false });
  const nodesRef = useRef(nodes);
  nodesRef.current = nodes;

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const isSelectAllCombo =
        (event.metaKey || event.ctrlKey) &&
        !event.altKey &&
        !event.shiftKey &&
        event.key.toLowerCase() === 'a';

      if (!isSelectAllCombo) return;

      // Focus guard: let the browser handle select-all-text inside inputs.
      if (isEditableTextTarget(document.activeElement)) return;

      event.preventDefault();
      selectAll(nodesRef.current);
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [selectAll]);
};

export default useSelectAllShortcut;
